








































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

import { PlanRunStatusAll } from '@/components/index' // 运行状态
import CardItemHead from '../CardItemHead/index.vue'

@Component({
  components: {
    CardItemHead,
    PlanRunStatusAll
  },
})
export default class CardItem extends Vue {
  /**
   *
   * headTitleType    CardItemHead组件type add为新增组件 edit为设置组件
   *
   * cardArr cardItem 卡片数据显示
   */
  @Prop() cardArr!: any[];
  @Prop() headTitleType!: string;

  // 点击卡片 item
  @Emit()
  onItemClick(item: any) {
    return item
  }

  // 头部编辑
  onEdit(id: string | number, card:any) {
    this.$emit('on-edit', id, card)
  }
  // 头部删除
  @Emit()
  onDel(id: string | number) {
    return id
  }
}
